import {
    // Fetch segment
    FETCH_SEGMENT_LIST,
    FETCH_SEGMENT_LIST_DATA,
    FETCH_SEGMENT_LIST_ERROR,

    // Create segment
    CREATE_NEW_SEGMENT_SUCCESS,
    CREATE_NEW_SEGMENT_ERROR,

    // Edit segment
    EDIT_SEGMENT_SUCCESS,
    EDIT_SEGMENT_ERROR,
} from 'Console/data/applicationDetail/segments/constants';

import { RESET_APPLICATION_DETAIL } from '../constants';

const initialState = {
    list: {
        data: [],
        hasError: false,
        isLoading: false,
    },
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case RESET_APPLICATION_DETAIL:
            return initialState;

        case FETCH_SEGMENT_LIST:
            return {
                ...state,
                list: {
                    ...state.list,
                    hasError: false,
                    isLoading: true,
                },
            };
        case FETCH_SEGMENT_LIST_DATA:
            return {
                ...state,
                list: {
                    data: payload,
                    hasError: false,
                    isLoading: false,
                },
            };

        case FETCH_SEGMENT_LIST_ERROR:
        case CREATE_NEW_SEGMENT_ERROR:
        case EDIT_SEGMENT_ERROR:
            return {
                ...state,
                list: {
                    ...state.list,
                    hasError: true,
                    isLoading: false,
                },
            };

        case CREATE_NEW_SEGMENT_SUCCESS:
            return {
                ...state,
                list: {
                    ...state.list,
                    data: [...state.list.data, payload],
                },
            };

        case EDIT_SEGMENT_SUCCESS:
            return {
                ...state,
                list: {
                    ...state.list,
                    data: state.list.data.map((segment) => {
                        if (segment.id !== payload.id) {
                            return segment;
                        }

                        return payload;
                    }),
                },
            };

        default:
            return state;
    }
};

export default reducer;
